import {
    DashboardRounded,
    GroupRounded,
    LocalHospitalRounded,
    MasksRounded,
    NoteAddRounded,
    HandshakeRounded,
    MedicalServicesRounded,
    LanguageRounded,
    VaccinesRounded,
    ScienceRounded,
    WorkspacesRounded,
    QueryStatsRounded,
    LocalLibraryRounded,
    SecurityRounded,
    PeopleRounded,
    HistoryRounded,
    HotelRounded,
    BedRounded,
} from '@mui/icons-material';

import { FeatureFlags } from '../config/featureFlags';

export interface SidebarRoute {
    name: string;
    icon: typeof DashboardRounded;
    permission: string[];
    path: string;
    featureFlag?: keyof FeatureFlags;
}

export const routes: SidebarRoute[] = [
    {
        name: 'Dashboard',
        icon: DashboardRounded,
        permission: [
            'SuperAdmin',
            'SystemAdministrator',
            'FacilityUser',
            'CHO',
            'Doctor',
            'Receptionist',
            'Nurse',
            'LabUser',
        ],
        path: '/dashboard',
    },
    {
        name: 'Dashboard',
        icon: DashboardRounded,
        permission: ['InsuranceProvider'],
        path: '/insurance?tab=dashboard',
    },
    {
        name: 'Users',
        icon: GroupRounded,
        permission: ['SuperAdmin', 'SystemAdministrator', 'FacilityUser'],
        path: '/users',
    },
    {
        name: 'Facility',
        icon: LocalHospitalRounded,
        permission: ['SuperAdmin', 'SystemAdministrator'],
        path: '/facility',
    },
    {
        name: 'Admitted Patients',
        icon: BedRounded,
        permission: [
            'SuperAdmin',
            'SystemAdministrator',
            'FacilityUser',
            'CHO',
            'Doctor',
            'Receptionist',
            'Nurse',
            'LabUser',
        ],
        path: '/facility-configuration',
        featureFlag: 'ipdModule',
    },
    {
        name: 'Units',
        icon: LocalLibraryRounded,
        permission: ['SuperAdmin', 'SystemAdministrator'],
        path: '/units',
    },
    {
        name: 'Patients',
        icon: MasksRounded,
        permission: [
            'SuperAdmin',
            'SystemAdministrator',
            'FacilityUser',
            'Receptionist',
            'Nurse',
        ],
        path: '/patients',
    },
    {
        name: 'Patients Visit',
        icon: NoteAddRounded,
        permission: [
            'FacilityUser',
            'SuperAdmin',
            'SystemAdministrator',
            'CHO',
            'Doctor',
            'Receptionist',
            'Nurse',
        ],
        path: '/patients-visit',
    },
    {
        name: 'Patient Admission',
        icon: HotelRounded,
        permission: [
            'SuperAdmin',
            'SystemAdministrator',
            'FacilityUser',
            'Receptionist',
            'Nurse',
        ],
        path: '/ipd-admission',
        featureFlag: 'ipdModule',
    },
    {
        name: 'Insurance',
        icon: SecurityRounded,
        permission: ['SuperAdmin', 'SystemAdministrator', 'FacilityUser'],
        path: '/insurance',
    },
    {
        name: 'Consultation',
        icon: HandshakeRounded,
        permission: [
            'CHO',
            'Doctor',
            'SuperAdmin',
            'SystemAdministrator',
            'FacilityUser',
        ],
        path: '/consultation',
    },
    {
        name: 'Services',
        icon: MedicalServicesRounded,
        permission: ['SuperAdmin', 'SystemAdministrator'],
        path: '/services',
    },
    {
        name: 'ICD 10',
        icon: LanguageRounded,
        permission: ['SuperAdmin', 'SystemAdministrator'],
        path: '/icd-10',
    },
    {
        name: 'Drugs',
        icon: VaccinesRounded,
        permission: ['SuperAdmin', 'SystemAdministrator', 'Doctor'],
        path: '/drugs',
    },
    {
        name: 'Lab Diagnostic',
        icon: ScienceRounded,
        permission: ['SuperAdmin', 'SystemAdministrator'],
        path: '/lab-diagnostic',
    },
    {
        name: 'Lab Orders',
        icon: WorkspacesRounded,
        permission: [
            'LabUser',
            'SuperAdmin',
            'SystemAdministrator',
            'FacilityUser',
            'Receptionist',
        ],
        path: '/lab-orders',
    },
    {
        name: 'Beneficiaries',
        icon: PeopleRounded,
        permission: ['InsuranceProvider'],
        path: '/insurance-provider/beneficiaries',
    },
    {
        name: 'Plans',
        icon: SecurityRounded,
        permission: ['InsuranceProvider'],
        path: '/insurance-provider/plans',
    },
    {
        name: 'Beneficiary Usage',
        icon: HistoryRounded,
        permission: ['InsuranceProvider'],
        path: '/insurance-provider/beneficiary-usage',
    },
    {
        name: 'Associated Facilities',
        icon: LocalHospitalRounded,
        permission: ['InsuranceProvider'],
        path: '/insurance-provider/facilities',
    },
    {
        name: 'Reports',
        icon: QueryStatsRounded,
        permission: [
            'SuperAdmin',
            'SystemAdministrator',
            'FacilityUser',
        ],
        path: '/reports',
    },
];
